import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import Movie from './Movie';

const Row = ({ title, fetchURL, rowId }) => {

    //variable to store the movie of a certain type 
    //from the TMDB API.
    const [movies, setMovies] = useState([])

    //Call the api only when this particular component mounts.
    useEffect(() => {
        axios.get(fetchURL).then((response) => {
            //set the movie variable with the details of the movie
            //id, title, image. 
            setMovies(response.data.results)
        })
    }, [fetchURL]);

    //slider function to slide the movies to the left.
    const slideLeft = () => {
        var slider = document.getElementById('slider' + rowId)
        slider.scrollLeft = slider.scrollLeft - 500;
    }
    //slider function to slide the movies to the right.
    const slideRight = () => {
        var slider = document.getElementById('slider' + rowId)
        slider.scrollLeft = slider.scrollLeft + 500;
    }

    return (
        <>
            {/* row title*/}
            <h2 className="text-white font-bold md:text-xl p-4">{title}</h2>
            <div className='relative flex items-center group'>
                {/* Left slider icon*/}
                <MdChevronLeft
                    onClick={slideLeft}
                    className="bg-white left-0 absolute opacity-50 hover:opacity-100 cursor-pointer z-10 hidden group-hover:block" size={40} />
                <div id={'slider' + rowId} className='w-full h-full overflow-x-scroll whitespace-nowrap scroll-smooth scrollbar-hide relative'>
                    {/* Movie image component.*/}
                    {movies.map((item, id) => (
                        //individual movie thumbnails
                        <Movie key={id} item={item} />
                    ))}
                </div>
                {/* Right slider icon*/}
                <MdChevronRight
                    onClick={slideRight}
                    className="bg-white right-0 absolute opacity-50 hover:opacity-100 cursor-pointer z-10 hidden group-hover:block" size={40} />
            </div>

        </>
    )
}

export default Row